import { useRef } from 'react';
import { avoidBreakAfter } from '@provider/print';
import { useKatex } from '@utils/react';
import { media } from './shared.style.js';
import { jsx } from 'react/jsx-runtime';

function TextMedia(props) {
  const ref = useRef(null);
  useKatex(ref);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: media,
    dangerouslySetInnerHTML: {
      __html: props.node.text.replaceAll("\n", "<br>")
    },
    ...(props.avoidBreakAfter ? avoidBreakAfter() : undefined)
  });
}

export { TextMedia };
//# sourceMappingURL=text.js.map
